// Taken from `chart.js`
export const adjustAxes = (chart, helpers) => {
  var yScale = chart.scales['y-axis-0']
  var chartArea = chart.chartArea

  yScale.ctx.save()
  yScale.ctx.globalCompositeOperation = 'destination-over'
  helpers.each(
    yScale.ticks,
    function(label, index) {
      if (label === undefined || label === null) return
      if (index === 0) return // dont draw the top line

      var yLineValue = this.getPixelForTick(index)
      yLineValue += helpers.aliasPixel(this.ctx.lineWidth)

      // Draw gridlines
      this.ctx.save()
      this.ctx.lineWidth = this.options.gridLines.lineWidth
      this.ctx.strokeStyle = 'rgba(100, 100, 100, 0.15)'

      this.ctx.beginPath()
      this.ctx.moveTo(chartArea.left, yLineValue)
      this.ctx.lineTo(chartArea.right, yLineValue)
      this.ctx.stroke()
      this.ctx.restore()

      // Draw labels
      this.ctx.save()
      this.ctx.translate(20, yLineValue)
      this.ctx.font = '12px sofia-pro, sans-serif'
      this.ctx.textBaseline = 'bottom'
      this.ctx.textAlign = 'left'
      this.ctx.fillStyle = 'rgba(100, 100, 100, 0.4)'
      this.ctx.fillText(Number(label).toFixed(2), 0, 0)
      this.ctx.restore()
    },
    yScale
  )

  yScale.ctx.restore()
  yScale.ctx.save()
  yScale.ctx.fillStyle = 'white'
  yScale.ctx.globalCompositeOperation = 'destination-over'
  yScale.ctx.fillRect(0, yScale.bottom, chartArea.right, chartArea.bottom)
  yScale.ctx.restore()
}
